import { jsPDF } from "jspdf";

const brl = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);

// Gera e baixa um comprovante/extrato de repasse em PDF
export const generateRepasseReceipt = (repasse) => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const now = new Date();
  const dateStr = now.toLocaleDateString("pt-BR");
  const timeStr = now.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  const txId =
    "VLC-" + now.getTime().toString(36).toUpperCase().slice(-8);

  // Header band
  doc.setFillColor(37, 99, 235);
  doc.rect(0, 0, pageW, 90, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.text("VeloClin", 40, 45);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text("Comprovante de Repasse Médico", 40, 66);
  doc.setFontSize(9);
  doc.text(`v1.0 MVP · Extrato Pix`, pageW - 40, 45, { align: "right" });
  doc.text(`${dateStr} ${timeStr}`, pageW - 40, 62, { align: "right" });

  // Body
  doc.setTextColor(15, 23, 42);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("Repasse liberado com sucesso", 40, 140);

  doc.setDrawColor(226, 232, 240);
  doc.line(40, 155, pageW - 40, 155);

  const rows = [
    ["Médico", repasse.doctor],
    ["Especialidade", repasse.specialty || "-"],
    ["Atendimentos realizados", String(repasse.atendimentos ?? "-")],
    ["Produção bruta", brl(repasse.producaoBruta)],
    ["Taxa de repasse", `${repasse.taxa}%`],
    ["Forma de pagamento", "Pix"],
    ["ID da transação", txId],
    ["Data / Hora", `${dateStr} ${timeStr}`],
  ];

  let y = 185;
  doc.setFontSize(11);
  rows.forEach(([label, val]) => {
    doc.setFont("helvetica", "normal");
    doc.setTextColor(100, 116, 139);
    doc.text(label, 40, y);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(15, 23, 42);
    doc.text(String(val), pageW - 40, y, { align: "right" });
    y += 26;
  });

  // Total box
  y += 10;
  doc.setFillColor(236, 253, 245);
  doc.roundedRect(40, y, pageW - 80, 60, 8, 8, "F");
  doc.setTextColor(4, 120, 87);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text("Valor líquido pago ao médico", 60, y + 26);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.text(brl(repasse.valorLiquido), pageW - 60, y + 38, { align: "right" });

  // Footer
  doc.setTextColor(148, 163, 184);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(
    "Documento gerado automaticamente pelo VeloClin CFO de Bolso.",
    40,
    doc.internal.pageSize.getHeight() - 40
  );

  const fileName = `repasse-${repasse.doctor.replace(/\s+/g, "-").toLowerCase()}-${dateStr.replace(/\//g, "-")}.pdf`;
  doc.save(fileName);
};

// Recibo de pagamento registrado na recepção (agenda)
export const generatePaymentReceipt = (p) => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const now = new Date();
  const dateStr = now.toLocaleDateString("pt-BR");
  const timeStr = now.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  const txId = "REC-" + now.getTime().toString(36).toUpperCase().slice(-8);

  doc.setFillColor(37, 99, 235);
  doc.rect(0, 0, pageW, 90, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.text("VeloClin", 40, 45);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text("Recibo de Pagamento — Recepção", 40, 66);
  doc.setFontSize(9);
  doc.text("v1.0 MVP", pageW - 40, 45, { align: "right" });
  doc.text(`${dateStr} ${timeStr}`, pageW - 40, 62, { align: "right" });

  doc.setTextColor(15, 23, 42);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("Pagamento registrado com sucesso", 40, 140);
  doc.setDrawColor(226, 232, 240);
  doc.line(40, 155, pageW - 40, 155);

  const rows = [
    ["Paciente", p.patient],
    ["Procedimento", p.procedure || "-"],
    ["Médico responsável", p.doctor || "-"],
    ["Forma de pagamento", p.method],
    ["Repasse Clínica", brl(p.repasseClinica)],
    ["Repasse Médico", brl(p.repasseMedico)],
    ["ID do recibo", txId],
    ["Data / Hora", `${dateStr} ${timeStr}`],
  ];

  let y = 185;
  doc.setFontSize(11);
  rows.forEach(([label, val]) => {
    doc.setFont("helvetica", "normal");
    doc.setTextColor(100, 116, 139);
    doc.text(label, 40, y);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(15, 23, 42);
    doc.text(String(val), pageW - 40, y, { align: "right" });
    y += 26;
  });

  y += 10;
  doc.setFillColor(236, 253, 245);
  doc.roundedRect(40, y, pageW - 80, 60, 8, 8, "F");
  doc.setTextColor(4, 120, 87);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text("Valor recebido", 60, y + 26);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.text(brl(p.received), pageW - 60, y + 38, { align: "right" });

  doc.setTextColor(148, 163, 184);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(
    "Documento gerado automaticamente pelo VeloClin.",
    40,
    doc.internal.pageSize.getHeight() - 40
  );

  const fileName = `recibo-${(p.patient || "paciente").replace(/\s+/g, "-").toLowerCase()}-${dateStr.replace(/\//g, "-")}.pdf`;
  doc.save(fileName);
};

// Extrato consolidado de todos os repasses do período em um único PDF
export const generateExtratoConsolidado = (repasses, periodLabel) => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const now = new Date();
  const dateStr = now.toLocaleDateString("pt-BR");
  const timeStr = now.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });

  doc.setFillColor(15, 23, 42);
  doc.rect(0, 0, pageW, 90, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.text("VeloClin", 40, 45);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text(`Extrato Consolidado de Repasses · ${periodLabel}`, 40, 66);
  doc.setFontSize(9);
  doc.text(`${dateStr} ${timeStr}`, pageW - 40, 62, { align: "right" });

  // Table header
  let y = 130;
  const cols = [40, 200, 300, 400, 460, pageW - 40];
  doc.setTextColor(100, 116, 139);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text("MÉDICO", cols[0], y);
  doc.text("ATEND.", cols[1], y);
  doc.text("PRODUÇÃO", cols[2], y);
  doc.text("TAXA", cols[3], y);
  doc.text("LÍQUIDO", cols[5], y, { align: "right" });
  doc.setDrawColor(226, 232, 240);
  doc.line(40, y + 8, pageW - 40, y + 8);

  y += 30;
  doc.setFontSize(10);
  let total = 0;
  repasses.forEach((r) => {
    total += r.valorLiquido;
    doc.setFont("helvetica", "bold");
    doc.setTextColor(15, 23, 42);
    doc.text(r.doctor, cols[0], y);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(71, 85, 105);
    doc.text(String(r.atendimentos), cols[1], y);
    doc.text(brl(r.producaoBruta), cols[2], y);
    doc.text(`${r.taxa}%`, cols[3], y);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(4, 120, 87);
    doc.text(brl(r.valorLiquido), cols[5], y, { align: "right" });
    doc.setFont("helvetica", "normal");
    doc.setTextColor(148, 163, 184);
    doc.setFontSize(8);
    const st = r.status === "pago" ? "Pago via Pix" : r.status === "pronto" ? "Pronto para liberação" : "Processando";
    doc.text(st, cols[0], y + 13);
    doc.setFontSize(10);
    y += 34;
  });

  // Total
  y += 6;
  doc.setDrawColor(226, 232, 240);
  doc.line(40, y, pageW - 40, y);
  y += 24;
  doc.setFillColor(236, 253, 245);
  doc.roundedRect(40, y - 18, pageW - 80, 44, 8, 8, "F");
  doc.setFont("helvetica", "bold");
  doc.setTextColor(4, 120, 87);
  doc.setFontSize(12);
  doc.text("Total líquido de repasses", 60, y + 8);
  doc.setFontSize(16);
  doc.text(brl(total), pageW - 60, y + 10, { align: "right" });

  doc.setTextColor(148, 163, 184);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(
    "Documento gerado automaticamente pelo VeloClin CFO de Bolso. Extrato de repasses.",
    40,
    doc.internal.pageSize.getHeight() - 40
  );

  const safeLabel = periodLabel
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase();
  doc.save(`extrato-repasses-${safeLabel}-${dateStr.replace(/\//g, "-")}.pdf`);
};

// Extrato individual do médico (Portal de Transparência) em PDF
export const generateDoctorExtrato = (doctor, summary) => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const now = new Date();
  const dateStr = now.toLocaleDateString("pt-BR");
  const timeStr = now.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });

  doc.setFillColor(37, 99, 235);
  doc.rect(0, 0, pageW, 90, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.text("VeloClin", 40, 45);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text("Extrato de Repasses do Médico", 40, 66);
  doc.setFontSize(9);
  doc.text(`${dateStr} ${timeStr}`, pageW - 40, 62, { align: "right" });

  doc.setTextColor(15, 23, 42);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text(doctor.name, 40, 128);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(100, 116, 139);
  doc.text(`${doctor.specialty} · CRM ${doctor.crm}-${doctor.uf} · repasse por convênio`, 40, 146);

  let y = 178;
  const resumo = [
    ["Faturamento Bruto", brl(summary.bruto)],
    ["Seu Repasse Líquido", brl(summary.repasseLiquido)],
    ["Já Recebido", brl(summary.jaRecebido)],
    ["Pendente", brl(summary.pendente)],
  ];
  doc.setFontSize(11);
  resumo.forEach(([l, v]) => {
    doc.setFont("helvetica", "normal");
    doc.setTextColor(100, 116, 139);
    doc.text(l, 40, y);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(15, 23, 42);
    doc.text(v, pageW - 40, y, { align: "right" });
    y += 24;
  });

  y += 8;
  doc.setDrawColor(226, 232, 240);
  doc.line(40, y, pageW - 40, y);
  y += 24;
  const cols = [40, 120, 330, 430, pageW - 40];
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(100, 116, 139);
  doc.text("HORÁRIO", cols[0], y);
  doc.text("PACIENTE", cols[1], y);
  doc.text("VALOR", cols[2], y);
  doc.text("STATUS", cols[3], y);
  doc.text("REPASSE", cols[4], y, { align: "right" });
  y += 8;
  doc.line(40, y, pageW - 40, y);
  y += 22;
  doc.setFontSize(10);
  summary.mine.forEach((a) => {
    doc.setFont("helvetica", "bold");
    doc.setTextColor(15, 23, 42);
    doc.text(a.time, cols[0], y);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(71, 85, 105);
    doc.text(String(a.patient).slice(0, 26), cols[1], y);
    doc.text(brl(a.value), cols[2], y);
    doc.text(a.paid ? "Pago" : "Pendente", cols[3], y);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(4, 120, 87);
    doc.text(brl(a._repasse ?? 0), cols[4], y, { align: "right" });
    doc.setFont("helvetica", "normal");
    doc.setTextColor(148, 163, 184);
    doc.setFontSize(8);
    doc.text(a._convenio || "Particular", cols[1], y + 11);
    doc.setFontSize(10);
    y += 28;
    if (y > doc.internal.pageSize.getHeight() - 60) {
      doc.addPage();
      y = 60;
    }
  });

  doc.setTextColor(148, 163, 184);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(
    "Documento gerado pelo VeloClin.",
    40,
    doc.internal.pageSize.getHeight() - 40
  );

  const safeName = doctor.name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase();
  doc.save(`extrato-${safeName}-${dateStr.replace(/\//g, "-")}.pdf`);
};

// Relatório de atuação do médico (gerado ao remover do corpo clínico)
export const generateDoctorReport = (doctor, s) => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const now = new Date();
  const dateStr = now.toLocaleDateString("pt-BR");
  const timeStr = now.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });

  doc.setFillColor(15, 23, 42);
  doc.rect(0, 0, pageW, 90, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.text("VeloClin", 40, 45);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text("Relatório de Atuação do Médico", 40, 66);
  doc.setFontSize(9);
  doc.text(`${dateStr} ${timeStr}`, pageW - 40, 62, { align: "right" });

  doc.setTextColor(15, 23, 42);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text(doctor.name, 40, 128);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(100, 116, 139);
  doc.text(
    `${doctor.specialty} · CRM ${doctor.crm}-${doctor.uf} · repasse ${doctor.repasse}%`,
    40,
    146
  );
  doc.text(`Período de uso considerado: últimos ${s.periodoMeses} meses`, 40, 162);

  const rows = [
    ["Pacientes atendidos (únicos)", String(s.pacientesUnicos)],
    ["Total de atendimentos realizados", String(s.totalAtendimentos)],
    ["Média mensal de atendimentos", `${s.mediaMensal} / mês`],
    ["Valor total faturado no período", brl(s.faturado)],
    ["Valor recebido no período", brl(s.recebido)],
  ];
  let y = 200;
  doc.setFontSize(11);
  rows.forEach(([l, v]) => {
    doc.setDrawColor(241, 245, 249);
    doc.line(40, y + 8, pageW - 40, y + 8);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(100, 116, 139);
    doc.text(l, 40, y);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(15, 23, 42);
    doc.text(v, pageW - 40, y, { align: "right" });
    y += 34;
  });

  doc.setTextColor(148, 163, 184);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(
    "Documento gerado automaticamente pelo VeloClin ao encerrar o vínculo.",
    40,
    doc.internal.pageSize.getHeight() - 40
  );

  const safe = doctor.name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase();
  doc.save(`relatorio-atuacao-${safe}-${dateStr.replace(/\//g, "-")}.pdf`);
};
